import { render, staticRenderFns } from "./ProgramItem.vue?vue&type=template&id=4ee05d73&scoped=true&"
import script from "./ProgramItem.vue?vue&type=script&lang=ts&"
export * from "./ProgramItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramItem.vue?vue&type=style&index=0&id=4ee05d73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee05d73",
  null
  
)

export default component.exports